/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { app__services__Automations__messages__automations__PersonRef } from "./app__services__Automations__messages__automations__PersonRef";
import type { StepSample } from "./StepSample";

/**
 * One step of the draft, as saving it would have it.
 */
export type StepPreview = {
  index: number;
  id?: number | null;
  ref?: string | null;
  action: StepPreview.action;
  words: string;
  position: string;
  reach?: number;
  people?: Array<app__services__Automations__messages__automations__PersonRef>;
  when?: string | null;
  note?: string | null;
  sample?: StepSample | null;
  ready?: number | null;
  here?: number;
  past?: number | null;
  moved?: number;
  cleared?: number;
};

export namespace StepPreview {
  export enum action {
    SEND = "send",
    TASK = "task",
    CRM_MOVE = "crm_move",
    CRM_FIELD = "crm_field",
    WAIT = "wait",
  }
}
